export const TEMPLATE_TYPES = {
  TEST: 'Test',
  AUDIENCE: 'Audience',
  CONSENT: 'Consent',
};

export const BUTTON_TEXT_MAP = {
  [TEMPLATE_TYPES.TEST]: 'Create Template',
  [TEMPLATE_TYPES.AUDIENCE]: 'Create Audience',
  [TEMPLATE_TYPES.CONSENT]: 'Upload consent form',
};

export const TITLE_MAP = {
  [TEMPLATE_TYPES.TEST]: 'Test Templates',
  [TEMPLATE_TYPES.AUDIENCE]: 'Audience Templates',
  [TEMPLATE_TYPES.CONSENT]: 'Consent Forms',
};

export const DESCRIPTION_MAP = {
  [TEMPLATE_TYPES.TEST]: 'Create a test template to use in your workspace.',
  [TEMPLATE_TYPES.AUDIENCE]: 'Create an audience template to use in your workspace.',
  [TEMPLATE_TYPES.CONSENT]: 'Participants are required to agree to your consent form before starting a study.',
};

export const NO_ITEMS_MESSAGE_MAP = {
  [TEMPLATE_TYPES.TEST]: 'No test templates yet.',
  [TEMPLATE_TYPES.AUDIENCE]: 'No audience templates yet.',
  [TEMPLATE_TYPES.CONSENT]: 'You haven’t uploaded a consent form yet',
};
